import 'angular:locale/data:hr';
import 'angular:locale/data:sk';
import 'angular:locale/data:hu';
import 'angular:locale/data:en';
import 'zone.js';(globalThis.$localize ??= {}).locale = "___NG_LOCALE_INSERT___";
